<script>
	// Async load the Vue 3 API
	import { defineAsyncComponent, defineComponent } from "vue";

	export default {
		components: {
			helloWorld: defineAsyncComponent(() =>
				import(/* webpackChunkName: "helloWorld" */ "../vue/HelloWorld.vue")
			),
			megaMenu: defineAsyncComponent(() =>
				import(/* webpackChunkName: "megaMenu" */ "../vue/MegaMenu.vue")
			),
			searchForm: defineAsyncComponent(() =>
				import(/* webpackChunkName: "SearchForm" */ "../vue/SearchForm.vue")
			),
			pseudoFooter: defineAsyncComponent(() =>
				import(/* webpackChunkName: "PseudoFooter" */ "../vue/PseudoFooter.vue")
			),
			videoModal: defineAsyncComponent(() =>
				import(/* webpackChunkName: "VideoModal" */ "../vue/VideoModal.vue")
			),
			accordion: defineAsyncComponent(() =>
				import(/* webpackChunkName: "accordion" */ "../vue/Accordion.vue")
			),
			// MultiSelectField: defineAsyncComponent(() => import( /* webpackChunkName: "MultiSelectField" */ '../vue/MultiSelectField.vue')),
			schoolMap: defineAsyncComponent(() =>
				import(/* webpackChunkName: "schoolMap" */ "../vue/Map.vue")
			),
			postscribe: defineAsyncComponent(() =>
				import(/* webpackChunkName: "postscribe" */ "../vue/Postscribe.vue")
			),

			// Icons as Components
			iconChevronDown: defineAsyncComponent(() =>
				import(
					/* webpackChunkName: "iconChevronDown" */ "../vue/icons/ChevronDown.vue"
				)
			),
			iconChevronRight: defineAsyncComponent(() =>
				import(
					/* webpackChunkName: "iconChevronRight" */ "../vue/icons/ChevronRight.vue"
				)
			),
			iconChevronLeft: defineAsyncComponent(() =>
				import(
					/* webpackChunkName: "iconChevronLeft" */ "../vue/icons/ChevronLeft.vue"
				)
			),
			iconCircleArrowRight: defineAsyncComponent(() =>
				import(
					/* webpackChunkName: "iconCircleArrowRight" */ "../vue/icons/CircleArrowRight.vue"
				)
			),
			iconSearch: defineAsyncComponent(() =>
				import(/* webpackChunkName: "iconSearch" */ "../vue/icons/Search.vue")
			),
			iconTimes: defineAsyncComponent(() =>
				import(/* webpackChunkName: "iconTimes" */ "../vue/icons/Times.vue")
			),
			iconFacebook: defineAsyncComponent(() =>
				import(
					/* webpackChunkName: "iconFacebook" */ "../vue/icons/Facebook.vue"
				)
			),
			iconTwitter: defineAsyncComponent(() =>
				import(/* webpackChunkName: "iconTwitter" */ "../vue/icons/Twitter.vue")
			),
			iconLinkedin: defineAsyncComponent(() =>
				import(
					/* webpackChunkName: "iconLinkedin" */ "../vue/icons/Linkedin.vue"
				)
			),
			iconRss: defineAsyncComponent(() =>
				import(/* webpackChunkName: "iconRss" */ "../vue/icons/Rss.vue")
			),
			iconPlace: defineAsyncComponent(() =>
				import(/* webpackChunkName: "iconPlace" */ "../vue/icons/Place.vue")
			),
		},
		methods: {
			// Pre-render pages when the user mouses over a link
			// Usage: <a href="" @mouseover="prerenderLink"
			prerenderLink: function (e) {
				const head = document.getElementsByTagName("head")[0];
				const refs = head.childNodes;
				const ref = refs[refs.length - 1];

				const elements = head.getElementsByTagName("link");
				Array.prototype.forEach.call(elements, function (el, i) {
					if ("rel" in el && el.rel === "prerender") {
						el.parentNode.removeChild(el);
					}
				});

				if (ref.parentNode && e.currentTarget) {
					const target = e.currentTarget;
					const prerenderTag = document.createElement("link");
					prerenderTag.rel = "prerender";
					prerenderTag.href = target.href;
					ref.parentNode.insertBefore(prerenderTag, ref);
				}
			},
		},
	};
</script>
